import Audi from '../../assets/makes/audi.svg'
import BMW from '../../assets/makes/bmw.svg'
import Ford from '../../assets/makes/ford.svg'
import Mercedes from '../../assets/makes/mercedes_benz.svg'
import Opel from '../../assets/makes/opel.svg'
import Peugot from '../../assets/makes/peugeot.svg'
import Seat from '../../assets/makes/seat.svg'
import Skoda from '../../assets/makes/skoda.svg'
import VW from '../../assets/makes/volkswagen.svg'

const DummyIcon = (_p: { className?: string }) => null
const carMakes = [
  { name: 'Abarth', Icon: DummyIcon },
  { name: 'AIWAYS', Icon: DummyIcon },
  { name: 'Aixam / Mega', Icon: DummyIcon },
  { name: 'Alfa Romeo', Icon: DummyIcon },
  { name: 'Alpine', Icon: DummyIcon },
  { name: 'Aston Martin', Icon: DummyIcon },
  { name: 'Audi', Icon: Audi },
  { name: 'Bentley', Icon: DummyIcon },
  { name: 'BMW', Icon: BMW },
  { name: 'BYD', Icon: DummyIcon },
  { name: 'Cadillac', Icon: DummyIcon },
  { name: 'Chevrolet', Icon: DummyIcon },
  { name: 'Chrysler', Icon: DummyIcon },
  { name: 'Citroën', Icon: DummyIcon, alias: 'Citroen' },
  { name: 'Cupra', Icon: DummyIcon },
  { name: 'Dacia', Icon: DummyIcon },
  { name: 'Dodge', Icon: DummyIcon },
  { name: 'DS Automobiles', Icon: DummyIcon },
  { name: 'EVO', Icon: DummyIcon },
  { name: 'Ferrari', Icon: DummyIcon },
  { name: 'Fiat', Icon: DummyIcon },
  { name: 'Ford', Icon: Ford },
  { name: 'Genesis', Icon: DummyIcon },
  { name: 'Honda', Icon: DummyIcon },
  { name: 'Hyundai', Icon: DummyIcon },
  { name: 'INEOS', Icon: DummyIcon },
  { name: 'Infiniti', Icon: DummyIcon },
  { name: 'Jaguar', Icon: DummyIcon },
  { name: 'Jeep', Icon: DummyIcon },
  { name: 'Kia', Icon: DummyIcon },
  { name: 'Lamborghini', Icon: DummyIcon },
  { name: 'Lancia', Icon: DummyIcon },
  { name: 'Land Rover', Icon: DummyIcon },
  { name: 'Lexus', Icon: DummyIcon },
  { name: 'Lotus', Icon: DummyIcon },
  { name: 'MAN', Icon: DummyIcon },
  { name: 'Maserati', Icon: DummyIcon },
  { name: 'Maxus', Icon: DummyIcon },
  { name: 'Mazda', Icon: DummyIcon },
  { name: 'McLaren', Icon: DummyIcon },
  { name: 'Mercedes-Benz', Icon: Mercedes },
  { name: 'MG', Icon: DummyIcon },
  { name: 'MINI', Icon: DummyIcon },
  { name: 'Mitsubishi', Icon: DummyIcon },
  { name: 'Nissan', Icon: DummyIcon },
  { name: 'Opel', Icon: Opel },
  { name: 'Peugeot', Icon: Peugot },
  { name: 'Polestar', Icon: DummyIcon },
  { name: 'Porsche', Icon: DummyIcon },
  { name: 'Renault', Icon: DummyIcon },
  { name: 'Rolls Royce', Icon: DummyIcon },
  { name: 'Rover', Icon: DummyIcon },
  { name: 'Seat', Icon: Seat },
  { name: 'Škoda', Icon: Skoda, alias: 'Skoda' },
  { name: 'Smart', Icon: DummyIcon },
  { name: 'Subaru', Icon: DummyIcon },
  { name: 'Suzuki', Icon: DummyIcon },
  { name: 'Tesla', Icon: DummyIcon },
  { name: 'Toyota', Icon: DummyIcon },
  { name: 'Volvo', Icon: DummyIcon },
  { name: 'VW', Icon: VW, alias: 'Volkswagen' },
] as const

export default carMakes
export type CarMake = (typeof carMakes)[number]

export const topCarMakes = (
  [
    'BMW',
    'VW',
    'Mercedes-Benz',
    'Audi',
    'Opel',
    'Seat',
    'Škoda',
    'Ford',
    'Peugeot',
  ] satisfies CarMake['name'][]
).map((name) => carMakes.find((m) => m.name === name)!)
